import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/containers/OnBoarding/redux/slice";
import {
  selectIsLoading,
  selectOnboardingList,
  selectSetupForm,
} from "app/containers/OnBoarding/redux/selector";

export function useSetupForm() {
  const dispatch = useDispatch();
  const form = useSelector(selectSetupForm);
  const onboardingList = useSelector(selectOnboardingList);
  const loading = useSelector(selectIsLoading);

  const setFormValue = (name: string, value: any) => {
    dispatch(actions.setSetupFormValue({ name, value }));
  };

  const saveForm = (isFrom: "teamCreate" | "isFinish", callback: () => void) => {
    dispatch(actions.saveSetupRequest({ isFrom, callback }));
  };

  return { form, onboardingList, loading, setFormValue, saveForm };
}
